customElements.define("stroked-text", class extends HTMLElement {
    static observedAttributes = ["text"];
    static measurementText = null;

    connectedCallback() {
        if (this.initialised) {
            return;
        }
        this.initialised = true;

        this.autoWidth = !this.hasAttribute("width");
        this.textWidth = Number(this.getAttribute("width"));
        this.textHeight = Number(this.getAttribute("height"));
        this.strokeWidth = Number(this.getAttribute("stroke-width"));
        this.alignment = this.getAttribute("align") ?? "centre";
        this.inset = Number(this.getAttribute("inset") ?? 0);
        this.fontAttributes = {
            "font-family": this.getAttribute("font-family") ?? "TankTrouble",
            "font-weight": this.getAttribute("font-weight") ?? "normal",
            "font-size": this.getAttribute("font-size"),
            "letter-spacing": this.getAttribute("letter-spacing") ?? 0
        };

        const shadow = this.attachShadow({ mode: "closed" });

        const style = document.createElement("style");
        style.textContent = ":host { display: inline-block; }";
        shadow.appendChild(style);

        this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        this.svg.setAttribute("part", "svg");
        this.svg.setAttribute("height", this.textHeight);

        this.textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
        for (const [name, value] of Object.entries(this.fontAttributes)) {
            this.textElement.setAttribute(name, value);
        }
        this.textElement.setAttribute("y", this.getAttribute("baseline") ?? this.fontAttributes["font-size"]);
        this.textElement.setAttribute("fill", this.getAttribute("fill") ?? "white");
        this.textElement.setAttribute("text-anchor", { left: "start", right: "end" }[this.alignment] ?? "middle");
        this.textElement.setAttribute("stroke", this.getAttribute("stroke") ?? "black");
        this.textElement.setAttribute("stroke-linejoin", "round");
        this.textElement.setAttribute("stroke-width", this.strokeWidth);
        this.textElement.setAttribute("paint-order", "stroke");

        this.svg.appendChild(this.textElement);
        shadow.appendChild(this.svg);

        this._render();
    }

    attributeChangedCallback() {
        if (this.initialised) {
            this._render();
        }
    }

    _render() {
        const text = this.getAttribute("text") ?? "";
        this.textElement.textContent = text;

        const requiredWidth = this.constructor._measure(text, this.fontAttributes) + this.strokeWidth + (2 * this.inset);
        const width = this.autoWidth ? requiredWidth : this.textWidth;
        const x = { left: this.inset, right: width - this.inset }[this.alignment] ?? width / 2;
        this.svg.setAttribute("width", width);
        this.textElement.setAttribute("x", x);

        const scale = Math.min(1.0, width / Math.max(requiredWidth, 1));
        const translateX = (x / scale) - x;
        const translateY = ((this.textHeight / scale) - this.textHeight) * 0.5;
        this.textElement.setAttribute("transform", `scale(${scale}) translate(${translateX}, ${translateY})`);
    }

    static _measure(text, fontAttributes) {
        if (this.measurementText === null) {
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            svg.style.position = "absolute";
            svg.style.visibility = "hidden";

            this.measurementText = document.createElementNS("http://www.w3.org/2000/svg", "text");
            svg.appendChild(this.measurementText);
            document.body.appendChild(svg);
        }

        for (const [name, value] of Object.entries(fontAttributes)) {
            this.measurementText.setAttribute(name, value);
        }
        this.measurementText.textContent = text;

        return this.measurementText.getComputedTextLength();
    }
});
